import { createMockCreator } from '@csp/test-common-utils';
import { StudyV1 } from '../generated/models/StudyV1';

const studyV1Mock: StudyV1 = {
  status: 'ACTREC',
  dcode: 'D1532C00065',
  name: 'Test study',
  studySetup: {
    automaticMetricsSyncEnabled: false,
    automaticStudySubjectSyncEnabled: false,
    automaticStudySyncEnabled: false,
  },
};

export const createStudyV1Mock = createMockCreator(studyV1Mock);
